import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAlert } from '../contexts'
import { FetchState, StatusType } from '../hooks'
import { APIErrorType } from './errors/types/errorTypes'
import { AlertSeverity } from './types'

export interface SubmitCheckerProps<T> {
  fetchState: FetchState<T>
  successFn?: () => void
  successMessageId?: string
  errorFn?: () => void
  errorMessageFn?: (error: APIErrorType) => string
  errorMessageId?: string
}

export const SubmitChecker = <T,>({
  fetchState,
  successFn,
  successMessageId,
  errorFn,
  errorMessageFn,
  errorMessageId
}: SubmitCheckerProps<T>) => {
  const { formatMessage } = useIntl()
  const { isSubmitting } = useFormikContext()
  const { setAlertType } = useAlert()

  useEffect(() => {
    const getMessage = (id?: string) => {
      return id ? formatMessage({ id }) || '' : undefined
    }
    if (isSubmitting) {
      setAlertType(undefined)
    }
    if (fetchState.status === StatusType.FETCHED) {
      successFn?.()
      setAlertType({
        severity: AlertSeverity.SUCCESS,
        message: getMessage(successMessageId)
      })
    } else if (fetchState.status === StatusType.ERROR) {
      const errorMsgFromAPI = errorMessageFn
        ? errorMessageFn(fetchState.error)
        : ''

      const errorMsg = errorMsgFromAPI || getMessage(errorMessageId)

      errorFn?.()
      setAlertType({
        severity: AlertSeverity.ERROR,
        message: errorMsg
      })
    }
  }, [
    errorMessageFn,
    errorMessageId,
    fetchState,
    successMessageId,
    errorFn,
    successFn,
    isSubmitting,
    setAlertType,
    formatMessage
  ])

  return null
}
